export default "__VITE_ASSET__C2$XBa1v__";